import { render } from "./OrderRow.vue?vue&type=template&id=55e40e7c&scoped=true"
import script from "./OrderRow.vue?vue&type=script&lang=js"
export * from "./OrderRow.vue?vue&type=script&lang=js"

import "./OrderRow.vue?vue&type=style&index=0&id=55e40e7c&scoped=true&lang=css"

import exportComponent from "/Users/fredde/programvara/boove.se/w3.boove.se/w3.boove.se/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-55e40e7c"]])

export default __exports__